import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
`;

export const LoadingContent = styled.h2`
  font-weight: bold;
  color: #a8a8a8;
`;

type SpinnerProps = {
  isButton?: boolean;
};

export const LoadingSpinner = styled.div<SpinnerProps>`
  border-style: solid;
  border-color: ${props => (props.isButton ? '#ffffffff' : '#005CDE')};
  border-width: ${props => (props.isButton ? '2px' : '6px')};
  border-bottom-color: transparent;
  border-radius: 50%;
  width: ${props => (props.isButton ? '20px' : '48px')};
  height: ${props => (props.isButton ? '20px' : '48px')};
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
